"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MUST_VALIDATE_CGU_QUIETLY = exports.SIMILAR_INVITATION_WORKFLOW = exports.RESUME_WORKFLOW = exports.CGU_VALIDATION = exports.DONE_WORKLOW = exports.FULL_CREATION_WORKFLOW = void 0;
exports.FULL_CREATION_WORKFLOW = 'MUST_CREATE_FULL_ACCOUNT';
exports.DONE_WORKLOW = 'ALREADY_DONE';
exports.CGU_VALIDATION = 'MUST_VALIDATE_CGU';
exports.RESUME_WORKFLOW = 'MUST_RESUME';
exports.SIMILAR_INVITATION_WORKFLOW = 'SIMILAR_INVITATION_ALREADY_CONSUMED';
exports.MUST_VALIDATE_CGU_QUIETLY = 'MUST_VALIDATE_CGU_QUIETLY';
